const PRIMARY_COLOR = "primary";
const SECONDARY_OPTION = "secondary";
const NONE_OPTION = "none";
const INITIAL_OPTION = "initial";
const CONTAIN_OPTION = "contain";
export {
  CONTAIN_OPTION,
  INITIAL_OPTION,
  NONE_OPTION,
  PRIMARY_COLOR,
  SECONDARY_OPTION
};
//# sourceMappingURL=constants.es.js.map
